import React from 'react';
import Section from '../components/Section';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  return (
    <>
      <SEO
        title="Oppdragsvilkår - Alminnelige betingelser"
        description="Les våre oppdragsvilkår og alminnelige betingelser for juridiske tjenester hos Advokatfirmaet Bruland."
        canonicalUrl="/oppdragsvilkar"
        noindex={true}
      />
      {/* Page Header */}
      <Section
        title="Oppdragsvilkår"
        subtitle="Alminnelige betingelser (Del 2)"
        background="gray"
        spacing="md"
        centered
      />

      {/* Introduction */}
      <Section background="white" spacing="lg" container="narrow">
        <p className="text-lg leading-relaxed text-gray-700 mb-8 italic">
          Denne siden inneholder advokatfirmaets generelle oppdragsvilkår. Den gjelder for alle oppdrag som er inngått uavhengig av om det foreligger en skriftlig oppdragsbekreftelse (Del 1) eller ikke. (Oppdragsvilkårene er oppdatert 19.08.22 og er i hovedsak basert på Advokatforeningens utkast)
        </p>

        {/* 1. INNLEDNING */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">1. Innledning</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Disse alminnelige betingelser gjelder for alle oppdrag som firmaets advokater eller ansatte påtar seg eller utfører i henhold til DEL I.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Disse alminnelige betingelser overgis klienten ved etablering av oppdraget og anses vedtatt av klienten med mindre klienten innen rimelig tid tilkjennegir ovenfor ansvarlig advokat at vilkårene ikke aksepteres.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.3</h3>
              <p className="text-gray-700 leading-relaxed">
                Med mindre annet er avtalt, gjelder betingelsene ved gjentatte oppdrag for samme klient.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.4</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaets mål og forpliktelse er å fremme klientens interesser på best mulig måte, innenfor de rammer som følger av denne oppdragsavtale, domstolloven, advokatforskriften, Regler for god advokatskikk, advokatfirmaets interne saksbehandlingsrutiner, samt andre relevante regelverk.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.5</h3>
              <p className="text-gray-700 leading-relaxed">
                Alle advokater og advokatfullmektiger tilknyttet firmaet har bevilling eller autorisasjon til å drive advokatvirksomhet i Norge utstedt av Tilsynsrådet for advokatvirksomhet. Samtlige advokater og advokatfullmektiger er medlemmer i Advokatforeningen og dermed underlagt Advokatforeningens særskilte vedtak og ordninger for obligatorisk etterutdanning og behandling av disiplinærklager.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">1.6</h3>
              <p className="text-gray-700 leading-relaxed">
                I samsvar med Advokatforeningens veiledning om hvordan menneskerettighetene forventes å bli respektert i advokatvirksomheter vil ansvarlig advokat ta initiativ til å drøfte aktuelle og potensielle menneskerettighetskrenkelser som oppdraget kan medføre, med det siktemål å bistå klienten med å unngå slike krenkelser. Advokatfirmaet forbeholder seg retten til å trekke seg fra oppdraget dersom klienten beslutter å ikke følge advokatens råd og det er klart for advokaten at hele eller deler av oppdraget kan medføre krenkelse av menneskerettigheter.
              </p>
            </div>
          </div>
        </div>

        {/* 2. ETABLERING OG GJENNOMFØRING */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">2. Etablering og gjennomføring av oppdraget</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Oppdragets beskrivelse fremgår av DEL I, supplert av de avtaler som følger av annen muntlig eller skriftlig korrespondanse. Ved betydelig endring av oppdraget skal klienten motta oppdatert DEL I av oppdragsbekreftelsen.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Alle oppdrag knyttes til en ansvarlig advokat i advokatfirmaet, som vil kunne få bistand fra firmaets øvrige ansatte til gjennomføringen av deler av oppdraget.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.3</h3>
              <p className="text-gray-700 leading-relaxed">
                I henhold til hvitvaskingsloven skal det som hovedregel gjennomføres kundetiltak med identifikasjonskontroll. Klienten plikter å medvirke til gjennomføring av kundetiltak. Det gjøres oppmerksom på at advokatfirmaet, ved mistanke om at transaksjoner har tilknytning til utbytte av straffbar handling mv., er pålagt å underrette ØKOKRIM om dette, likevel uten å underrette klienten eller tredjepersoner.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.4</h3>
              <p className="text-gray-700 leading-relaxed">
                Før et oppdrag etableres, vil det bli søkt avklart om det foreligger interessekonflikt eller andre forhold som tilsier at advokatfirmaet ikke kan eller bør påta seg oppdraget. Klienten plikter å bidra til slik avklaring. Den samme vurderingen gjøres i etablerte oppdrag ved nye parters inntreden i saken. Dersom hensynet til klienten tilsier det og det finnes ubetenkelig, kan oppdraget påbegynnes før avklaringen er fullført. Advokatfirmaet kan i slike tilfeller måtte frasi seg oppdraget senere på grunn av dette.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.5</h3>
              <p className="text-gray-700 leading-relaxed">
                For best mulig å kunne fremme klientens interesser, er advokatfirmaet avhengig av at klienten fullstendig og snarest gir informasjon om sakens faktiske forhold og hvilket resultat klienten ønsker å oppnå i saken.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.6</h3>
              <p className="text-gray-700 leading-relaxed">
                Alle henvendelser til og fra motparten skal avklares med eller gå gjennom advokatfirmaet. Advokatfirma og klient skal holde hverandre gjensidig orientert om den kommunikasjon som finner sted med involverte parter.
              </p>
            </div>
          </div>
        </div>

        {/* 3. SALÆRBEREGNING */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">3. Salærberegning og fakturering</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Med mindre annet er avtalt, er utgangspunktet for faktureringen av oppdraget den tid som er medgått til effektivt og fagmessig arbeid med oppdraget. Våre veiledende timesatser fremgår av oppdragsbekreftelsens DEL I.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Minste timeenhet er 0,25 time (15 minutter). Telefonsamtaler og lignende som ikke består av helt korte beskjeder, avregnes med minimum 0,25 time.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.3</h3>
              <p className="text-gray-700 leading-relaxed">
                Ved endelig salærfastsettelse ansvarlig advokat utøve et skjønn hvor det tas hensyn til arbeidets art og kompleksitet, sakens utfall, samt hvor effektivt oppdraget er utført hensett til advokatens erfaringsbakgrunn og spesialkompetanse. Salæret skal stå i rimelig forhold til oppdraget og arbeidet som er utført av advokaten og de øvrige av firmaets medarbeidere.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.4</h3>
              <p className="text-gray-700 leading-relaxed">
                Klienten er ansvarlig for rettsgebyr, omkostninger til sakkyndige vitner og andre omkostninger som påløper ved en rettslig prosess. Klienten er også ansvarlig for motpartens saksomkostninger hvis de blir ilagt. Saksomkostninger vil ofte, men ikke alltid, kunne belastes den part som ikke får medhold.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.5</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaets salærkrav mot klienten begrenses ikke av at klienten blir tilkjent mindre i erstatning for saksomkostninger enn salærkravets pålydende.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.6</h3>
              <p className="text-gray-700 leading-relaxed">
                Lovmessige begrensninger i klientens adgang til å kreve erstattet kostnader til rettshjelp fra motparten begrenser ikke advokatfirmaets salærkrav mot klienten. Slike begrensninger er fastsatt blant annet ved saker for forliksrådet og i småkravsprosess.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.7</h3>
              <p className="text-gray-700 leading-relaxed">
                Med faktura skal følge spesifisert oversikt over utført arbeid, utlegg mv.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.8</h3>
              <p className="text-gray-700 leading-relaxed">
                Alle omkostninger og utlegg som advokatfirmaet forskutterer, vil bli fakturert sammen med krav på salær. Viderefakturering av utlegg vil kunne medføre merverdiavgift på utlegget.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.9</h3>
              <p className="text-gray-700 leading-relaxed">
                Ved forsinket betaling påløper forsinkelsesrente i henhold til forsinkelsesrentelovens bestemmelser.
              </p>
            </div>
          </div>
        </div>

        {/* Continue with sections 4-8... */}
        {/* 4. EKSTERN DEKNING */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">4. Ekstern dekning av salærkostnader</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">4.1</h3>
              <p className="text-gray-700 leading-relaxed">
                I henhold til lov om fri rettshjelp kan det for visse saker gis rett til advokatbistand som dekkes av det offentlige (fri rettshjelp). Noen sakstyper kvalifiserer alltid for fri rettshjelp, andre sakstyper forutsetter at klienten ikke har inntekt eller formue over hhv. kr. 246.000 (enslige), kr. 369 000 (ektepar, registrerte partnere, m.m.) og kr. 100.000 (nettoformue). Fylkesmannen kan i visse tilfelle gjøre unntak fra grensene. Nærmere informasjon om fri rettshjelp kan fås hos Fylkesmannen eller ved vårt kontor. Klienten oppfordres til å ta spørsmålet om fri rettshjelpsdekning opp med ansvarlig advokat for en konkret vurdering.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">4.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Klientens eventuelle rettshjelpsforsikring, innboforsikring, reiseforsikring eller andre forsikringsordninger kan dekke kostnader til advokatbistand i visse sakstyper, avhengig av vilkårene i forsikringsavtalen. Klienten plikter å gi advokatfirmaet de nødvendige opplysninger for en vurdering av forsikringsavtalens dekningsomfang. Klienten er selv ansvarlig for eventuell egenandel eller mellomlegg mellom advokatfirmaets salærkrav og det beløp forsikringsselskapet dekker.
              </p>
            </div>
          </div>
        </div>

        {/* 5. ANSVAR */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">5. Advokatfirmaets ansvar</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet er ansvarlig i henhold til alminnelige regler om advokaters profesjonsansvar og er dekket av den lovpålagte sikkerhetsstillelse for utøvelse av advokatvirksomhet, som gjelder uten geografisk begrensning. Advokatfirmaets sikkerhetsstiller er det firmaet som det er tegnet avtale med gjennom Den Norske Advokatforening.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Med mindre annet er avtalt, omfatter ikke oppdraget rådgivning i forhold til sakens skatte- og avgiftsrettslige sider.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.3</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet er ikke ansvarlig for indirekte tap, herunder tapt fortjeneste.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.4</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet er ikke ansvarlig for feil begått av rådgivere som advokatfirmaet har henvist til eller for underleverandører som advokatfirmaet etter avtale med klienten har overlatt deler av oppdragsutførelsen til.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.5</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet er ikke ansvarlig for tap som følge av at sakens resultat ikke samsvarer med den vurdering advokatfirmaet på forhånd har gitt av sakens mulige utfall.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.6</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet er ikke ansvarlig for tap av forvaltede klientmidler som følge av konkurs eller andre forhold på bankens side. Advokatfirmaet gjør oppmerksom på at bankenes sikringsfond ikke garanterer for mer enn 2 millioner kroner i innskudd pr innskyter (advokatfirma) pr. bank. Kun ved særskilt avtale om det vil advokatfirmaet treffe tiltak som kan øke graden av garantidekning for klientens midler.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.7</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaets ansvar er begrenset oppad til det beløp som advokatfirmaets ansvarsforsikring til enhver tid dekker.
              </p>
            </div>
          </div>
        </div>

        {/* 6. BEHANDLING AV INFORMASJON */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">6. Behandling av informasjon</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">6.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokater i advokatfirmaet har forbud mot rettstridig å røpe betrodde hemmeligheter. I tillegg plikter advokatene også å behandle opplysninger utover dette fortrolig. I visse lovbestemte tilfeller gjelder unntak fra taushets- og fortrolighetsplikten.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">6.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Med mindre noe annet er avtalt, har advokatfirmaets advokater adgang til å dele opplysningene med andre medarbeidere i firmaet så langt det er nødvendig. Advokatfirmaets øvrige medarbeidere er underlagt den samme taushets- og fortrolighetsplikt som advokatene.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">6.3</h3>
              <p className="text-gray-700 leading-relaxed">
                I den grad det er nødvendig for oppfyllelse av oppdraget vil advokatfirmaet behandle personopplysninger, herunder også særlige kategorier personopplysninger om det er nødvendig, i samsvar med personopplysningsloven og annet regelverk. Andre parter, som motparter, domstol og offentlige organer, vil kun få tilgang til personopplysningene i den grad dette er nødvendig for oppdraget. Klienten har rett til innsyn i og informasjon om de behandlede opplysninger, samt adgang til å kreve retting av mangelfulle opplysninger. Behandlingsansvarlig etter personopplysningsloven er advokatfirmaet ved daglige leder og ved spørsmål om vår behandling av personopplysninger kan saksansvarlig advokat kontaktes. Se også om behandling av personopplysninger i advokatfirmaets personvernerklæring.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">6.4</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatfirmaet gjør oppmerksom på at elektronisk datakommunikasjon generelt lider av svakheter som innebærer at uvedkommende under gitte forutsetninger kan få innsyn i kommunikasjonen. I den grad konfidensialitet er nødvendig, vil det kunne treffes sikringstiltak (herunder kryptering og sladding) for å hindre uautorisert innsyn i slik kommunikasjon. Som et moment i vurderingen om konfidensialitet er nødvendig, vil vektlegges klientens sending av usikret elektronisk informasjon til advokatfirmaet.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">6.5</h3>
              <p className="text-gray-700 leading-relaxed">
                Ved avslutning av oppdraget gis eventuelle originale dokumenter i saken tilbake til klienten eller makuleres etter nærmere avtale. Advokatfirmaet er pålagt å lagre visse dokumenter og opplysninger etter oppdragets avslutning. Advokatfirmaet kan oppbevare kopi også av øvrige saksdokumenter etter oppdragets avslutning, innenfor de rammer som følger av lovverket. Kopier kan utleveres mot vederlag.
              </p>
            </div>
          </div>
        </div>

        {/* 7. KLAGE */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">7. Klage</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">7.1</h3>
              <p className="text-gray-700 leading-relaxed">
                Dersom klienten er misfornøyd med utførelsen av oppdraget eller salærberegningen, oppfordres klienten til straks å ta dette opp med ansvarlig advokat eller daglig leder. Advokatfirmaet vil umiddelbart vurdere de påklagede forhold.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">7.2</h3>
              <p className="text-gray-700 leading-relaxed">
                Advokatforeningens disiplinærutvalg behandler klager over at advokaten skal ha opptrådt i strid med regler for god advokatskikk eller skal ha krevd for høyt salær. Klagen må som hovedregel fremsettes innen seks måneder etter at klageren ble kjent med eller burde ha blitt kjent med det forhold klagen bygger på. Disiplinærutvalgene har kompetanse til å gi kritikk, irettesettelse og advarsel til advokaten, og til å redusere salærkravet mot klienten. Disiplinærutvalgenes beslutning kan påklages til Disiplinærnemnden. Mer informasjon kan gis ved henvendelse til Advokatforeningens eller på www.advokatenhjelperdeg.no.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">7.3</h3>
              <p className="text-gray-700 leading-relaxed">
                Tvister knyttet til oppdragsavtalen avgjøres etter norsk rett og kan kun bringes inn for norske domstoler.
              </p>
            </div>
          </div>
        </div>

        {/* 8. REVISJON */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">8. Revisjon av oppdragsvilkår</h2>

          <p className="text-gray-700 leading-relaxed">
            De alminnelige betingelser for oppdraget revideres normalt en gang i året og ellers når det oppstår behov for det. Endringer til ugunst for klienten, som ikke er nødvendige på grunn av bindende regelverk, kan først gjøres gjeldende etter én måneds varsel.
          </p>
        </div>

        {/* Last Updated */}
        <div className="mt-12 pt-8 border-t border-gray-300">
          <p className="text-sm text-gray-600 italic">
            Sist oppdatert: 19. august 2022
          </p>
        </div>
      </Section>
    </>
  );
};

export default Terms;
